import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

export enum AlertTypes {
  Info = 'INFO',
  Error = 'ERROR',
}

type AlertProps = {
  title?: string | ReactNode;
  content?: string | ReactNode;
  type?: AlertTypes;
  testId?: string;
  noMaxWidth?: boolean;
};

type UnavailableWrapperProps = {
  type: AlertTypes;
  noMaxWidth?: boolean;
};

const UnavailableWrapper = styled.div<UnavailableWrapperProps>`
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  padding: 18px 23px;
  font-size: 19px;
  background: ${({ theme }) => theme.defaultColors.infoBackground} 0% 0% no-repeat padding-box;
  border: 1px solid ${({ theme }) => theme.defaultColors.info};
  border-radius: 4px;
  max-width: ${({ noMaxWidth }) => (noMaxWidth ? 'unset' : '950px')};
  margin: 20px 0;

  ${({ type }) =>
    type === AlertTypes.Error &&
    css`
      color: ${({ theme }) => theme.defaultColors.error};
      background: ${({ theme }) => theme.defaultColors.errorBackground} 0% 0% no-repeat padding-box;
      border: 1px solid ${({ theme }) => theme.defaultColors.error};
    `}
`;

const Header = styled.h4`
  font-size: 18px;
  line-height: 22px;
  margin: 0 0 5px 0;
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;

const Message = styled.p`
  max-width: 500px;
  font-size: 15px;
  line-height: 21px;
  margin: 0;
`;

const Alert: React.FC<AlertProps> = ({ title, content, type = AlertTypes.Info }) =>
  title || content ? (
    <UnavailableWrapper type={type}>
      {!!title && <Header>{title}</Header>}
      {!!content && <Message>{content}</Message>}
    </UnavailableWrapper>
  ) : null;

export const AlertWithChildren = ({
  type = AlertTypes.Info,
  children,
  testId = '',
  noMaxWidth = false,
}) => (
  <UnavailableWrapper noMaxWidth={noMaxWidth} data-testid={testId} type={type}>
    {children}
  </UnavailableWrapper>
);
export default Alert;
